import { gql } from "@apollo/client";

export const PLATFORM_INTEGRATION_FIELDS = gql`
  fragment PlatformIntegrationFields on PlatformIntegration {
    id
    category
    provider
    name
    status
    isDefault
    values {
      key
      value
    }
    storedSecrets
    missingFields
    supportedCardHolderTypes
    createdAt
    updatedAt
    cardProducts {
      key
      name
      displayName
      subAccountType
      cardHolderTypes
      supportedCardHolderTypes
      enabled
      rewards
    }
  }
`;

export const GET_PLATFORM_INTEGRATIONS = gql`
  ${PLATFORM_INTEGRATION_FIELDS}
  query getPlatformIntegrations($category: PlatformIntegrationCategory) {
    myPlatform {
      id
      platformIntegrations(category: $category) {
        ...PlatformIntegrationFields
      }
    }
  }
`;

export const GET_PLATFORM_INTEGRATION = gql`
  ${PLATFORM_INTEGRATION_FIELDS}
  query getPlatformIntegration($id: ID!) {
    platformIntegration(id: $id) {
      ...PlatformIntegrationFields
    }
  }
`;

export const GET_PLATFORM_INTEGRATION_TEMPLATES = gql`
  query getPlatformIntegrationTemplates {
    platformIntegrationTemplates {
      category
      provider
      label
      domain
      descriptionKey
      hasCardProducts
      sections {
        key
        labelKey
        descriptionKey
        forSubAccountTypes
        fields {
          key
          type
          labelKey
          helpKey
          required
          concealed
          maxLength
          placeholder
          endpointUrl
          options {
            value
            label
          }
          defaultValue
        }
      }
    }
  }
`;

export const SAVE_PLATFORM_INTEGRATION = gql`
  ${PLATFORM_INTEGRATION_FIELDS}
  mutation savePlatformIntegration($input: SavePlatformIntegrationInput!) {
    savePlatformIntegration(input: $input) {
      ...PlatformIntegrationFields
    }
  }
`;

export const CHECK_PLATFORM_INTEGRATION = gql`
  mutation checkPlatformIntegration($input: CheckPlatformIntegrationInput!) {
    checkPlatformIntegration(input: $input) {
      ok
      message
    }
  }
`;

export const REFRESH_ISSUER_CARD_PRODUCTS = gql`
  ${PLATFORM_INTEGRATION_FIELDS}
  mutation refreshIssuerCardProducts($id: ID!) {
    refreshIssuerCardProducts(id: $id) {
      ...PlatformIntegrationFields
    }
  }
`;

export const UPDATE_ISSUER_CARD_PRODUCT = gql`
  ${PLATFORM_INTEGRATION_FIELDS}
  mutation updateIssuerCardProduct(
    $id: ID!
    $productKey: String!
    $input: IssuerCardProductUpdate!
  ) {
    updateIssuerCardProduct(id: $id, productKey: $productKey, input: $input) {
      ...PlatformIntegrationFields
    }
  }
`;

const COMPANY_CARD_PROGRAM_SETTING_FIELDS = gql`
  fragment CompanyCardProgramSettingFields on CompanyCardProgramSetting {
    platformIntegrationId
    integrationName
    cardIssuer
    productKey
    displayName
    subAccountType
    cardHolderTypes
    platformEnabled
    access
    program {
      id
      nickname
      cardHolderType
      cardHolderTypeOptions
      cardDesign {
        id
        name
      }
      cardDesignOptions {
        id
        name
      }
    }
  }
`;

export const GET_COMPANY_CARD_PROGRAM_SETTINGS = gql`
  ${COMPANY_CARD_PROGRAM_SETTING_FIELDS}
  query companyCardProgramSettings($companyId: ID!) {
    companyCardProgramSettings(companyId: $companyId) {
      ...CompanyCardProgramSettingFields
    }
  }
`;

export const SET_COMPANY_CARD_PROGRAM_ACCESS = gql`
  ${COMPANY_CARD_PROGRAM_SETTING_FIELDS}
  mutation setCompanyCardProgramAccess(
    $companyId: ID!
    $platformIntegrationId: ID!
    $productKey: String!
    $access: CardProgramAccess!
  ) {
    setCompanyCardProgramAccess(
      companyId: $companyId
      platformIntegrationId: $platformIntegrationId
      productKey: $productKey
      access: $access
    ) {
      ...CompanyCardProgramSettingFields
    }
  }
`;

export const SET_CARD_PROGRAM_DESIGN = gql`
  mutation setCardProgramDesign(
    $companyId: ID!
    $programId: ID!
    $designId: ID
  ) {
    setCardProgramDesign(
      companyId: $companyId
      programId: $programId
      designId: $designId
    ) {
      id
      cardDesign {
        id
        name
      }
    }
  }
`;

export const SET_CARD_PROGRAM_CARD_HOLDER_TYPE = gql`
  mutation setCardProgramCardHolderType(
    $companyId: ID!
    $programId: ID!
    $cardHolderType: CardHolderType!
  ) {
    setCardProgramCardHolderType(
      companyId: $companyId
      programId: $programId
      cardHolderType: $cardHolderType
    ) {
      id
      cardHolderType
    }
  }
`;
